import { useEffect, useState } from "react";
import { allVariantsPartnerFulfils } from "../../../utils/variantUtils";
import { getFeature } from "../../utils/features";
import { SUSTAINABILITY_INFO_CONFIG } from "../../constants";
import { useStockPrice } from "../../context/stockPrice/StockPriceContext";
import { useRuntimeConstants } from "../../context/runtimeConstants/RuntimeConstantsContext";
import { useFeaturesReady } from "../../context/featuresReady/FeaturesReadyContext";

function isValidSustainabilityStore(storeId) {
  return SUSTAINABILITY_INFO_CONFIG.some(
    (sustainabilityInfoStore) =>
      sustainabilityInfoStore.store.toLowerCase() === storeId?.toLowerCase()
  );
}

export function useSustainabilityInfo() {
  const { areFeaturesReady } = useFeaturesReady();
  const [shouldRenderSustainabilityInfo, setShouldRenderSustainabilityInfo] =
    useState(false);

  const { products: product } = useStockPrice();

  const { webContext } = useRuntimeConstants();

  useEffect(() => {
    if (areFeaturesReady && product) {
      setShouldRenderSustainabilityInfo(
        !!isValidSustainabilityStore(webContext?.storeId) &&
          !allVariantsPartnerFulfils(product.variants) &&
          getFeature("pdp-sustainability-info").isEnabled()
      );
    }
  }, [product, areFeaturesReady, webContext]);

  return shouldRenderSustainabilityInfo;
}
